import * as actionTypes from "../ActionTypes";

export const getRolesAction = (payload) => {
  return {
    type: actionTypes.GET_ROLES_REQUEST,
    payload: payload,
  };
};

export const saveCMSUserAction = (payload) => {
  return {
    type: actionTypes.SAVE_CMS_USER_REQUEST,
    payload: payload,
  };
};

export const getCMSUserAction = (payload) => {
  return {
    type: actionTypes.GET_CMS_USER_REQUEST,
    payload: payload,
  };
};

export const updateCMSUserAction = (payload) => {
  return {
    type: actionTypes.UPDATE_CMS_USER_REQUEST,
    payload: payload,
  };
};

export const deleteCMSUserAction = (payload) => {
  return {
    type: actionTypes.DELETE_CMS_USER_REQUEST,
    payload,
  };
};

export const setAdminUserPasswordAction = (payload) => {
  return {
    type: actionTypes.SET_ADMIN_USER_PASSWORD_REQUEST,
    payload,
  };
};

export const resyncUserAuth0ProfileAction = (payload) => {
  return {
    type: actionTypes.RESYNC_USER_AUTH0_PROFILE_REQUEST,
    payload,
  };
};

export const lookupCMSUserByEmailAction = (payload) => {
  return {
    type: actionTypes.LOOKUP_CMS_USER_BY_EMAIL_REQUEST,
    payload,
  };
};

export const updateUserProfileInfoAction = (payload) => {
  return {
    type: actionTypes.UPDATE_USER_PROFILE_INFO,
    payload: payload,
  };
};

export const setUserAccessTokenAction = (payload) => {
  return {
    type: actionTypes.SET_ACCESS_TOKEN,
    payload: payload,
  };
};


export const availableUsersAction = (payload) => ({
  type: actionTypes.AVAILABLE_USERS_REQUEST,
  payload,
});
export const saveUserCircleAction = (payload) => ({
    type: actionTypes.SAVE_USER_CIRCLE_REQUEST,
    payload,  
  });

  export const myCircleRequestsAction = (payload) => ({
    type: actionTypes.MY_CIRCLE_REQUESTS_REQUEST,
    payload,
  });
  
  export const updateUserCircleAction = (payload) => ({
    type: actionTypes.UPDATE_USER_CIRCLE_REQUEST,
    payload,
  });
  
  // AvailableUsersAction.js

export const myCircleListAction = (payload) => ({
    type: actionTypes.MY_CIRCLE_LIST_REQUEST,
    payload,
  });

  // Add this action creator to UsersAction.js
export const getChurchUsersAction = (payload) => ({
  type: actionTypes.GET_CHURCH_USERS_REQUEST,
  payload,
});

// Add this action creator to UsersAction.js
export const getNotificationsAction = (payload) => ({
  type: actionTypes.GET_NOTIFICATIONS_REQUEST,
  payload,
});
// Add this action creator to UsersAction.js
export const sendNotificationToOneAction = (payload) => ({
  type: actionTypes.SEND_NOTIFICATION_TO_ONE_REQUEST,
  payload,
});
